import MobileDetect from "mobile-detect";
import $ from 'jquery';

$(function() {
    /* Mobile Detection */
    var md = new MobileDetect(window.navigator.userAgent);
    if (md.mobile()) {
        $('body').addClass('mobile');
    }

    function uiShim(){
        //This function is nested b/c we have some variables that need to be in scope.
        //This bit does the actual work.
        function uiShimWork(){
            var lockBottomPage,
                currentOffsetPage,
                effectiveMenuHeightPage,
                lockBottomSite,
                currentOffsetSite,
                effectiveMenuHeightSite;

			// Set a document variable for backward compatability of detecting widths used below
            var root= document.compatMode=='BackCompat'? document.body : document.documentElement;

            // If we detect a horizontal scrollbar, reset the menus.
			// This should not be needed any more since we have mobile support, but leaving it in for now.
            var isHorizontalScrollbar= root.scrollWidth>root.clientWidth;
            if (!isHorizontalScrollbar){
                // If the menu is taller than the viewport, we need to make sure the menu is always visible
                // and to scroll it up & down properly when the user changes scroll direction.
                // We want to treat a non-scroll event like an up scroll so the menu is reset when re-sizing the window.
                if (siteMenuLocked){
                    lockBottomSite = menuHeightSite + siteHeaderHeight - viewportHeight;
                    currentOffsetSite = $(targetDivSite).offset().top;
                    $(targetDivSite).removeClass('affix');
                    effectiveMenuHeightSite = (menuHeightSite + siteHeaderHeight + 40) - lockTopSite;

                    if ((viewportHeight >= effectiveMenuHeightSite) && (viewportHeight >= mainWrapperHeight)){
                        //Viewport Tallest. Set to Default. No Scrolling.
                        if (pageTop > lockTopSite) {
                            // $(targetDivSite).removeClass('custom-scroll').addClass('affix').css('top', '');
                        }
                        else {
                            // $(targetDivSite).removeClass('affix custom-scroll');
                        }
                    }
                    else if ((mainWrapperHeight >= viewportHeight) && (mainWrapperHeight >= effectiveMenuHeightSite)){
                        //Content Tallest...'
                        if ((viewportHeight >= effectiveMenuHeightSite)){
                            //Viewport taller than menu. Lock Top. Menu is always available.
                            // Recalc lockTopSite b/c it may be wrong if loaded in mobile layout.
                            lockTopSite = $('#site-sidebar ul li:nth-of-type(1)').offset().top - 12;
                            if (pageTop > lockTopSite) {
                                // $(targetDivSite).removeClass('custom-scroll').addClass('affix').css('top', '');
                            }
                            else {
                                // $(targetDivSite).removeClass('affix custom-scroll');
                            }
                        }
                        else {
                            //Menu taller than viewport. Lock Top or Bottom, scroll menu on transition. This is the tricky bit...
                            if (scrollDiff >= 0){
                                //scrolling up
                                if (pageTop <= lockTopSite){
                                    // $(targetDivSite).addClass('custom-scroll').css('top', '');
                                }
                                else {
                                    if (!(currentOffsetSite < (pageTop - siteHeaderHeight))){
                                        //lock it to the top
                                        // $(targetDivSite).addClass('custom-scroll').css('top', (pageTop - lockTopSite));
                                    }
                                    // else Leave the top setting alone. It will scroll normally.
                                }
                            }
                            else if (scrollDiff < 0) {
                                //scrolling down
                                if (pageTop == (-1 * scrollDiff) && (pageTop > lockBottomSite)){
                                    //lock it to the bottom. This is to fix it on a reload event
                                    // $(targetDivSite).addClass('custom-scroll').css('top', (pageTop - lockBottomSite));
                                }
                                else if (pageTop <= lockBottomSite){
                                    // $(targetDivSite).addClass('custom-scroll').css('top', '');
                                }
                                else {
                                    if (!((currentOffsetSite + (menuHeightSite - viewportHeight)) > (pageTop))){
                                        //lock it to the bottom
                                        // $(targetDivSite).addClass('custom-scroll').css('top', (pageTop - lockBottomSite));
                                    }
                                    // else Leave the top setting alone. It will scroll normally.
                                }
                            }

                        }
                    }
                    else {
                        // Menu Tallest. Set to Default. Scrolling controlled by Menu, if it is the larger of the two.
                        if (menuHeightSite > menuHeightPage){
                            // $(targetDivSite).removeClass('affix custom-scroll');
                        }
                        else {
                            if (pageTop > lockTopSite) {
                                // $(targetDivSite).removeClass('custom-scroll').addClass('affix').css('top', '');
                            }
                            else {
                                // $(targetDivSite).removeClass('affix custom-scroll');
                            }
                        }
                    }
                }

                if (pageMenuLocked){
                    lockBottomPage = menuHeightPage + pageHeaderHeight + siteHeaderHeight - viewportHeight;
                    currentOffsetPage = $(targetDivPage).offset().top;
                    $(targetDivPage).removeClass('affix');
                    effectiveMenuHeightPage = (menuHeightPage + siteHeaderHeight + 40) - lockTopPage;

                    if ((viewportHeight >= effectiveMenuHeightPage) && (viewportHeight >= mainWrapperHeight)){
                        if (pageTop > lockTopPage) {
                            // $(targetDivPage).removeClass('custom-scroll').addClass('affix').css('top', '');
                        }
                        else {
                            // $(targetDivPage).removeClass('affix custom-scroll').css('top', '');;
                        }
                    }
                    else if ((mainWrapperHeight >= viewportHeight) && (mainWrapperHeight >= effectiveMenuHeightPage)){
                        if ((viewportHeight >= effectiveMenuHeightPage)){
                            // Recalc lockTopPage b/c it may be wrong if loaded in mobile layout.
                            lockTopPage = $('#page-sidebar ul.nav li:nth-of-type(2)').offset().top - 13;
                            if (pageTop > lockTopPage) {
                                // $(targetDivPage).removeClass('custom-scroll').addClass('affix').css('top', '');
                            }
                            else {
                                // $(targetDivPage).removeClass('affix custom-scroll').css('top', '');;
                            }
                        }
                        else {
                            if (scrollDiff >= 0){
                                if (pageTop <= lockTopPage){
                                    // $(targetDivPage).addClass('custom-scroll').css('top', '');
                                }
                                else {
                                    if (!(currentOffsetPage < (pageTop - siteHeaderHeight - pageHeaderHeight))){
                                        // Lock it to the top.
                                        // $(targetDivPage).addClass('custom-scroll').css('top', (pageTop - lockTopPage));
                                    }
                                    //else Leave the top setting alone. It will scroll normally.
                                }
                            }
                            else if (scrollDiff < 0) {
                                //scrolling down
                                if (pageTop == (-1 * scrollDiff) && (pageTop > lockBottomPage)){
                                    //lock it to the bottom. This is to fix it on a reload event
                                    // $(targetDivPage).addClass('custom-scroll').css('top', (pageTop - lockBottomPage));
                                }
                                else if (pageTop <= lockBottomPage){
                                    // $(targetDivPage).addClass('custom-scroll').css('top', '');
                                }
                                else {
                                    if (!((currentOffsetPage + (menuHeightPage - viewportHeight)) > (pageTop))){
                                        //lock it to the bottom
                                        // $(targetDivPage).addClass('custom-scroll').css('top', (pageTop - lockBottomPage));
                                    }
                                    //else Leave the top setting alone. It will scroll normally.
                                }
                            }
                        }
                    }
                    else {
                        // Menu Tallest. Set to Default. Scrolling controlled by Menu, if it is the larger of the two.
                        if (menuHeightPage > menuHeightSite){
                            // $(targetDivPage).removeClass('affix custom-scroll').css('top', '');;
                        }
                        else {
                            if (pageTop > lockTopPage) {
                                // $(targetDivPage).removeClass('custom-scroll').addClass('affix').css('top', '');
                            }
                            else {
                                // $(targetDivPage).removeClass('affix custom-scroll').css('top', '');;
                            }
                        }
                    }
                }
                lastScrollTop = pageTop;
            }
            else {
                // $(targetDivPage).removeClass('affix custom-scroll').css('top', '');
                // $(targetDivSite).removeClass('affix custom-scroll').css('top', '');
            }
        }

		if ($('#site-menu-widget').is(':visible')){
			// $(targetDivPage).removeClass('affix custom-scroll').css('top', '');
			// $(targetDivSite).removeClass('affix custom-scroll').css('top', '');
		}
		else {
	        var mainWrapperHeight = $('#main-page-wrapper').innerHeight();
            var secFooterHeight = $('footer.security-footer').innerHeight();

            var navbarHeight = $('nav.navbar').innerHeight();
            var secTopperHeight = 0;
            if ($('.security-topper').length > 0){
                secTopperHeight = $('.security-topper').innerHeight();
            }

	        var offsetHeight = navbarHeight + secFooterHeight + secTopperHeight;

	        var targetDivSite = '#site-sidebar';
            var menuHeightSite = 0;
            if ($(targetDivSite).length > 0){
                menuHeightSite = $(targetDivSite).innerHeight();
            }
            var targetDivPage = '#page-sidebar';
            var menuHeightPage = 0;
            if ($(targetDivPage).length > 0){
                menuHeightPage = $(targetDivPage).innerHeight();
            }

	        var newHeight = Math.max.apply(Math, [menuHeightSite, (menuHeightPage + secFooterHeight), (mainWrapperHeight - offsetHeight)])

            var pageHeaderHeight = $('#page-header').innerHeight(); //This is also used in uiShim().

            var newContentHeight = newHeight - pageHeaderHeight;

			// Sets the help flyout & page sidebar wrapper height
	        if ($('#page-sidebar-wrapper')){
	            $('#page-sidebar-wrapper').css('min-height',newContentHeight);
	        }
	        if ($('#page-help-flyout')){
	            $('#page-help-flyout').css('min-height',newContentHeight);
	        }

            // This sets the page footer up as sticky if the content size isn't scrolling
            // if ($('#page-footer').length > 0 && $('#main-content').length > 0){
            //     if ($('#main-content').height() <= $(window).height()) {
            //         $('#page-footer').addClass('sticky');
            //     }
            //     else {
            //         $('#page-footer').removeClass('sticky');
            //     }
            // }

            //Now we check the sidebars and do our best to keep them visible.
	        if (pageMenuLocked || siteMenuLocked){
	            var viewportHeight = $(window).height();
	            var contentHeight = $('#content-wrapper').height();
	            var mainWrapperHeight = $('#main-page-wrapper').innerHeight();
	            var siteHeaderHeight = $('nav.navbar').innerHeight() + secTopperHeight;
	            var pageTop = $(window).scrollTop();
	            var scrollDiff = lastScrollTop - pageTop;

	            // For the OSX & iOS "rubberband" effect when you scroll up
	            if (pageTop < 0) {
	                pageTop = 0;
	            }

	            uiShimWork();
	        }
		}
    }
	if (!md.mobile()) {
	    var siteMenuLocked = false;
	    var pageMenuLocked = false;

	    // The freescroll class indicates that the sidebars should not be locked on scrolling.
	    // The numbers subtracted from the .top() value are to match it up when anchored via CSS
	    if (typeof $('#site-sidebar > ul li:nth-of-type(1)').offset() != "undefined" && !$('#site-sidebar > ul').hasClass('freescroll')){
	        var lockTopSite = $('#site-sidebar ul li:nth-of-type(1)').offset().top - 12;
            siteMenuLocked = true;
	    }
	    if (typeof $('#page-sidebar > ul.nav li:nth-of-type(2)').offset() != "undefined" && !$('#page-sidebar > ul').hasClass('freescroll')){
	        var lockTopPage = $('#page-sidebar ul.nav li:nth-of-type(2)').offset().top - 13;
            pageMenuLocked = true;
	    }

	    if (pageMenuLocked || siteMenuLocked){
	        var lastScrollTop = 0;
	    }
	    $(window).scroll(uiShim);
	    $(window).resize(uiShim);
		window.addEventListener("orientationchange", function() {
			uiShim();
		}, false);
	    uiShim();
	}
});
